// University detail data — slug → rich info
// Slug is generated as: lowercase, non-word chars stripped, spaces → hyphens (see Universities.jsx)

export const universityData = {
  "kings-college-london": {
    name: "King's College London",
    country: "United Kingdom", city: "London", flag: "🇬🇧",
    type: "University", founded: 1829, students: "33,000+", ranking: "QS Top 40 World",
    tagline: "One of England's oldest and most prestigious universities — research powerhouse in central London.",
    programs: ["Business & Management", "Law", "Medicine", "International Relations", "Computer Science", "Psychology"],
    feeFrom: "£25,000", feeTo: "£42,000", language: "English", deadline: "January 2027",
    requirements: ["IELTS 6.5–7.0 / TOEFL 92+", "A-Levels AAA or equivalent", "Personal statement", "Reference letter"],
    why: ["Located in heart of London — Strand campus on the Thames", "Strong ties with top global employers and law firms", "Member of the prestigious Russell Group", "33,000+ students from 150+ countries"],
    website: "https://www.kcl.ac.uk"
  },
  "university-of-bristol": {
    name: "University of Bristol",
    country: "United Kingdom", city: "Bristol", flag: "🇬🇧",
    type: "University", founded: 1909, students: "32,000+", ranking: "QS Top 60 World",
    tagline: "Russell Group university with one of the strongest research reputations in the UK.",
    programs: ["Engineering", "Business & Economics", "Medicine", "Computer Science", "Veterinary Science", "Law"],
    feeFrom: "£26,000", feeTo: "£45,000", language: "English", deadline: "January 2027",
    requirements: ["IELTS 6.5+ / TOEFL 88+", "A-Levels AAA-AAB", "Foundation programme accepted", "Personal statement"],
    why: ["Top 10 UK universities for research", "Strong Foundation Programme via Kaplan pathway", "Vibrant student city — 25% of population are students", "Bristol scholarships available (£2,000+)"],
    website: "https://www.bristol.ac.uk"
  },
  "nottingham-trent-university": {
    name: "Nottingham Trent University",
    country: "United Kingdom", city: "Nottingham", flag: "🇬🇧",
    type: "University", founded: 1843, students: "37,000+", ranking: "Modern University of the Year",
    tagline: "One of the UK's most innovative modern universities with industry-aligned programmes.",
    programs: ["Business & Law", "Fashion & Textiles", "Computer Science", "Architecture", "Psychology", "Sports Science"],
    feeFrom: "£16,710", feeTo: "£18,700", language: "English", deadline: "Year-round (Foundation)",
    requirements: ["IELTS 5.5–6.0 (Foundation)", "Attestat with 4/12+ average", "International College pathway"],
    why: ["Foundation pathway via Nottingham Trent International College", "Scholarships up to £1,490 for international students", "98% graduate employment rate", "Modern campuses + accommodation included"],
    website: "https://www.ntu.ac.uk"
  },
  "the-hague-university-of-applied-sciences": {
    name: "The Hague University of Applied Sciences",
    country: "Netherlands", city: "The Hague", flag: "🇳🇱",
    type: "University", founded: 1987, students: "26,000+", ranking: "Top Dutch University of Applied Sciences",
    tagline: "International, applied-learning university in the political capital of Netherlands.",
    programs: ["International Business", "Applied Computer Science", "European Studies", "International Communication", "Public Management"],
    feeFrom: "€10,164", feeTo: "€14,950", language: "English / Dutch", deadline: "May 1, 2027",
    requirements: ["IELTS 6.0+ / TOEFL 80+", "Secondary education with 70%+", "Motivation letter"],
    why: ["Conditional offer pathway via The Hague Pathway College", "EU degree recognised across all 27 member states", "Internships built into every programme", "International student community (40%+ overseas)"],
    website: "https://www.thehagueuniversity.com"
  },
  "trinity-college-dublin": {
    name: "Trinity College Dublin",
    country: "Ireland", city: "Dublin", flag: "🇮🇪",
    type: "University", founded: 1592, students: "20,000+", ranking: "QS Top 100 World",
    tagline: "Ireland's oldest and most prestigious university — historic campus in central Dublin.",
    programs: ["Business", "Computer Science", "Engineering", "Medicine", "Law", "International Relations"],
    feeFrom: "€20,500", feeTo: "€32,000", language: "English", deadline: "February 2027",
    requirements: ["IELTS 6.5+ / TOEFL 90+", "Foundation programme (TIFP) available", "Personal statement"],
    why: ["Trinity Global Excellence Scholarship up to €4,000", "Historic 430-year-old campus in Dublin city centre", "QS Top 100 worldwide", "English-speaking EU country — work rights for graduates"],
    website: "https://www.tcd.ie"
  },
  "boston-university": {
    name: "Boston University",
    country: "USA", city: "Boston, MA", flag: "🇺🇸",
    type: "University", founded: 1839, students: "37,000+", ranking: "US News Top 45",
    tagline: "Major private research university in the heart of Boston with global reputation.",
    programs: ["Business (Questrom)", "Engineering", "Communication", "Computer Science", "International Relations", "Public Health"],
    feeFrom: "$62,000", feeTo: "$66,000", language: "English", deadline: "January 6, 2027",
    requirements: ["IELTS 7.0+ / TOEFL 90+", "SAT 1300+ or ACT 29+", "Personal essay + recommendations"],
    why: ["Located in Boston — top US student city", "100+ countries represented on campus", "Strong career outcomes — 95% graduate employment", "Master's pathways via Metropolitan College"],
    website: "https://www.bu.edu"
  },
  "arizona-state-university": {
    name: "Arizona State University",
    country: "USA", city: "Phoenix / LA", flag: "🇺🇸",
    type: "University", founded: 1885, students: "145,000+", ranking: "#1 Most Innovative US University (8 years running)",
    tagline: "Largest US public university by enrolment — known for innovation and accessibility.",
    programs: ["Business", "Engineering", "Computer Science", "Fashion Design", "Journalism", "Sustainability"],
    feeFrom: "$31,000", feeTo: "$36,000", language: "English", deadline: "Rolling admissions",
    requirements: ["IELTS 6.5+ / TOEFL 80+", "GPA 3.0+", "No SAT/ACT required for international"],
    why: ["#1 Most Innovative University in US (US News)", "Campuses in Phoenix + Los Angeles", "Hybrid + online learning options", "Strong career outcomes — Tesla, Intel partnerships"],
    website: "https://www.asu.edu"
  },
  "university-of-texas-at-san-antonio": {
    name: "University of Texas at San Antonio (UTSA)",
    country: "USA", city: "San Antonio, TX", flag: "🇺🇸",
    type: "University", founded: 1969, students: "34,000+", ranking: "R1 Doctoral Research University",
    tagline: "Fast-growing Texas state university with strong international student support via Shorelight.",
    programs: ["Business (BBA)", "Cybersecurity", "Engineering", "Computer Science", "Supply Chain Management", "Health Sciences"],
    feeFrom: "$28,000", feeTo: "$32,000", language: "English", deadline: "Rolling",
    requirements: ["IELTS 6.0+ / TOEFL 71+", "International Direct pathway via Shorelight", "Conditional offers available"],
    why: ["R1 top-tier research classification", "Strong cybersecurity programme — #1 in US (Ponemon)", "Affordable Texas state tuition", "Conditional admission via Shorelight pathway"],
    website: "https://www.utsa.edu"
  },
  "oregon-state-university": {
    name: "Oregon State University",
    country: "USA", city: "Corvallis, OR", flag: "🇺🇸",
    type: "University", founded: 1868, students: "36,000+", ranking: "Top 1.4% World (INTO partner)",
    tagline: "Major Pacific Northwest research university with renowned engineering and STEM programmes.",
    programs: ["Engineering", "Computer Science", "Business", "Bioengineering", "Forestry", "Marine Sciences"],
    feeFrom: "$36,000", feeTo: "$42,000", language: "English", deadline: "Rolling",
    requirements: ["IELTS 6.5+ / TOEFL 80+", "INTO OSU pathway available", "GPA 3.0+"],
    why: ["Top 1.4% of universities worldwide", "Tesla, Intel, Nvidia recruit directly", "INTO pathway for conditional offers", "West Coast career hub access"],
    website: "https://oregonstate.edu"
  },
  "schiller-international-university": {
    name: "Schiller International University",
    country: "Spain", city: "Madrid", flag: "🇪🇸",
    type: "University", founded: 1964, students: "1,200+", ranking: "Accredited dual EU/US",
    tagline: "Truly international university with 4 campuses across Europe and the US.",
    programs: ["International Relations & Diplomacy", "International Business", "Marketing", "Hospitality Management"],
    feeFrom: "€15,420", feeTo: "€19,000", language: "English", deadline: "Rolling",
    requirements: ["IELTS 5.5+ / TOEFL 71+", "Secondary education completion", "Application form + transcripts"],
    why: ["Up to 50% scholarship for strong applicants", "Study across Madrid, Paris, Heidelberg, Tampa campuses", "Dual EU + US accreditation", "Small class sizes (avg 12 students)"],
    website: "https://www.schiller.edu"
  },
  "anglo-american-university": {
    name: "Anglo-American University (AAU)",
    country: "Czech Republic", city: "Prague", flag: "🇨🇿",
    type: "University", founded: 1990, students: "800+", ranking: "WSCUC accredited (US)",
    tagline: "Oldest private university in Czech Republic with full US accreditation.",
    programs: ["Business Administration", "International Relations", "Law", "Humanities", "Journalism"],
    feeFrom: "€7,800", feeTo: "€9,200", language: "English", deadline: "Rolling",
    requirements: ["IELTS 6.0+ / TOEFL 71+", "Secondary education", "Admission interview"],
    why: ["WSCUC accredited — degree valid in US", "Affordable Prague tuition (€7,800/yr)", "EU degree recognition", "Historic city centre campus"],
    website: "https://www.aauni.edu"
  },
  "doverbroeck-s-oxford-nord-anglia": {
    name: "D'Overbroeck's Oxford (Nord Anglia)",
    country: "United Kingdom", city: "Oxford", flag: "🇬🇧",
    type: "Boarding School", founded: 1977, students: "750+", ranking: "Outstanding Ofsted",
    tagline: "Independent boarding school in Oxford — Sixth Form, IB and GCSE pathways.",
    programs: ["GCSE", "A Level", "International Baccalaureate (IB)", "Sixth Form"],
    feeFrom: "£11,795/term", feeTo: "£13,500/term", language: "English", deadline: "Year-round",
    requirements: ["CAT4 + English + Maths test", "B2 English / IELTS 6", "Reference from current school"],
    why: ["Nord Anglia Education global network", "Oxford location — direct university pathways", "Average 6 GCSE grades 6+", "Refundable deposit (£3,470)"],
    website: "https://www.doverbroecks.com"
  },
  "into-london": {
    name: "INTO London — STEM, Medicine & Health",
    country: "United Kingdom", city: "London", flag: "🇬🇧",
    type: "Pathway College", founded: 2005, students: "1,500+", ranking: "Top UK pathway provider",
    tagline: "International Foundation programme in central London for STEM, Medicine and Health.",
    programs: ["International Foundation — Medicine & Health", "Engineering Foundation", "Business Foundation"],
    feeFrom: "£21,000", feeTo: "£24,000", language: "English", deadline: "Rolling",
    requirements: ["IELTS 6.0 (Writing 6.0)", "Average 11/12 across subjects", "Math + Bio + Chem grade 11+"],
    why: ["Guaranteed progression to top UK universities", "Central London location (Middlesex St)", "3 terms intensive Foundation", "Pathway to St George's, Kings, Bristol Med"],
    website: "https://www.intostudy.com/into-london"
  },
  "oncampus-ireland": {
    name: "OnCampus Ireland",
    country: "Ireland", city: "Maynooth, Co. Kildare", flag: "🇮🇪",
    type: "Pathway College", founded: 2009, students: "500+", ranking: "Top Ireland pathway provider",
    tagline: "Foundation pathway to top Irish and European universities — medical, engineering & science routes.",
    programs: ["Foundation — Medicine Pathway", "Foundation — Engineering & Science", "Pre-Master's"],
    feeFrom: "€20,450", feeTo: "€22,000", language: "English", deadline: "Rolling",
    requirements: ["IELTS 5.5+", "Secondary education", "Strong science background for med pathway"],
    why: ["Medical pathway to Medical University Pleven", "English-speaking EU country", "Progression to top Irish universities", "Located on Maynooth campus"],
    website: "https://www.oncampus.global"
  }
};

// Default fallback for any slug we don't have data for
export const defaultUniversityInfo = {
  type: "University",
  language: "English",
  feeFrom: "By request",
  feeTo: "",
  tagline: "Детальна інформація про цей навчальний заклад надається за запитом — звʼяжіться з нашою командою для персональної консультації.",
  why: [
    "STUDYGRI — официальный партнёр многих ведущих университетов",
    "Индивидуальный подбор программы под ваш профиль",
    "Полное сопровождение: документы, виза, адаптация",
    "Помощь со стипендиями и грантами"
  ]
};
